// extracted by css-extract-rspack-plugin
export default {"text":"text-F1ZSGZ","upsell":"upsell-TOYxSp","messageBody":"messageBody-fEv7et","salesLink":"salesLink-pHYAg1"};